import { FC } from "react";
import { Handle, Position } from "react-flow-renderer";
import { makeStyles, Theme } from "@material-ui/core/styles";

interface RootBlockProps { }

const RootBlock: FC<RootBlockProps> = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Handle
        type="source"
        position={Position.Right}
        id="a"
        isConnectable={false}
      />
    </div>
  );
};

export default RootBlock;

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: "#FFFFFF",
    border: "9px solid #0468FD",
    borderRadius: "100%",
    width: "26px",
    height: "26px",
  },
}));
